import { createStore } from 'vuex'
import userService from './services/UserService'
import { compareScheduleTimes } from './utils/compareScheduleTimes'

const store = createStore({

    state(){
        return{
            list_music:[],
            list_spot: [],
            listSpotProg: [],
            horasProgramadas:[],
            isRepetidora: import.meta.env.VITE_REPETIDORA, // corrige aquí
            modoRadio:false,
            usuario:''
        }
    },

    mutations:{
        setModoRadio(state,modo){
            state.modoRadio=modo
        },
        loadProgMusic(state,listMusic){
            state.list_music = listMusic
        },
        loadProgSpot(state,listSpot){
            state.list_spot = listSpot
        },
        loadUsuario(state){
            state.usuario = userService.current()
        },
        loadHorasProgramadas(state,horas){
            state.horasProgramadas.push(horas)
            state.horasProgramadas.sort(compareScheduleTimes)
        },
        addProgSpot(state,spot){
            state.listSpotProg.push(spot)
        }
    }




})
export default store;
